import React from 'react';
import tokenServices from '../../../services/utils/tokenServices';
import { io } from 'socket.io-client';
import { useDispatch } from 'react-redux';
import { pushNotification, updateNotifications } from '../../../store/notification';
import { WebSocketMicroService } from '../../../services/microServices';

const AppNotificationSocket = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    const socket = initSocket();
    return () => {
      socket.close();
    };
  }, []);

  const initSocket = () => {
    const token = tokenServices.getTrackToken();
    let socket;
    socket = io(`${WebSocketMicroService}/?token=${token}`, {
      transports: ['websocket'],
      reconnectionAttempts: 2,
      // path:'',
    });
    socket.on('connect', () => {});
    socket.on('ack', (ack) => {
      if (ack) {
        socket.on('newRide', (data) => {
          dispatch(updateNotifications([data]));
          dispatch(pushNotification([data]));
        });
      }
    });
    socket.onclose = () => {
      console.log('WebSocket disconnected');
      socket = null;
    };

    socket.onerror = (error) => {
      console.error('WebSocket error: ', error);
    };
    return socket;
  };

  return null;
};

export default AppNotificationSocket;
